import { globalStyle, style } from '@vanilla-extract/css';

export const loginModalDialogContent = style({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'start',
  justifyContent: 'stretch',
  '@media': {
    'only screen and (--mobile)': {
      width: '100%',
      height: 'auto',
      maxHeight: '90vh',
      overflowY: 'scroll',
    },
  },
});

export const loginModalContentContainer = style({
  display: 'flex',
  margin: '0 auto',
  overflow: 'auto',
  position: 'relative',
  width: 'var(--width)',
  maxWidth: 'var(--max-width)',
  '@media': {
    'only screen and (--mobile)': {
      width: '100%',
      maxWidth: '100%',
      position: 'initial',
    },
  },
});

globalStyle(`${loginModalContentContainer}::-webkit-scrollbar`, {
  display: 'none',
});
